import script from "./RealtimeKujibikiCta.vue?vue&type=script&setup=true&lang=js"
export * from "./RealtimeKujibikiCta.vue?vue&type=script&setup=true&lang=js"

import "./RealtimeKujibikiCta.vue?vue&type=style&index=0&id=e6a9501c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6a9501c"]])

export default __exports__